import * as Yup from 'yup';
import { REQUIRED_FIELD } from '../../../../constants';

const EditProfileValidationSchema = Yup.object().shape({
  firstName: Yup.string().required(REQUIRED_FIELD),
  lastName: Yup.string().required(REQUIRED_FIELD),
});

export default EditProfileValidationSchema;
